function LastBookingInfo(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 20 20"
      fill="#3CC918"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M9.992 1.667c-4.6 0-8.325 3.733-8.325 8.333s3.725 8.333 8.325 8.333c4.608 0 8.341-3.733 8.341-8.333S14.6 1.667 9.992 1.667zm.008 15A6.665 6.665 0 013.333 10 6.665 6.665 0 0110 3.333 6.665 6.665 0 0116.667 10 6.665 6.665 0 0110 16.667z" />
      <path d="M10.417 5.833h-1.25v5l4.375 2.625.625-1.025-3.75-2.225V5.833z" />
    </svg>
  )
}

export default LastBookingInfo
